import { Button } from "@/components/ui/button";
import { useState } from "react";
import CryptoTransfer from "./CryptoTransfer";
import CryptoIcon from "@/icons/other/cryptoIcon";
import BankIcon from "@/icons/other/bankIcon";
import ComingSoonIcon from "@/icons/other/comingSoonIcon.tsx";
import CardPayment from "./CardPayment";

const DepositTab = () => {
  const [activeButton, setActiveButton] = useState("crypto");
  return (
    <div>
      <div
        className={`max-h-screen bg-[url('/login/login-back.png')] bg-cover text-white/30`}
      >
        <div
          className={`grid grid-cols-1 gap-4 md:grid-cols-1 ${activeButton === "crypto" ? "" : ""}`}
        >
          {/* Left Column for the Form */}
          <div className="flex w-full flex-col rounded-l-lg p-2 text-white ">
            <div className="mb-2 font-sans text-sm font-medium text-white/50 max-sm:hidden">
              Choose a Payment Method
            </div>
            <div className="mb-1 flex items-center gap-2">
              <div
                className={`flex-grow rounded-lg p-0.5 ${
                  activeButton === "crypto"
                    ? "bg-gradient-to-r from-[#003BD2] to-[#00FFC2] text-white"
                    : "bg-transparent"
                }`}
              >
                <Button
                  className={`w-full ${
                    activeButton === "crypto"
                      ? "bg-[#131431]"
                      : "h-11 rounded-lg border-2 border-solid border-white/10 bg-white/5"
                  } rounded-none px-4 py-2 text-sm font-normal sm:rounded-lg sm:font-bold`}
                  onClick={() => setActiveButton("crypto")}
                >
                  <div className="flex items-center gap-2">
                    <CryptoIcon />
                    <div>Crypto Transfer</div>
                  </div>
                </Button>
              </div>
              <div
                className={`flex-grow rounded-lg p-0.5 ${
                  activeButton === "bank"
                    ? "bg-gradient-to-r from-[#003BD2] to-[#00FFC2] text-white"
                    : "bg-transparent"
                }`}
              >
                <Button
                  disabled // Card payment temporarily disabled
                  className={`flex-grow ${
                    activeButton === "bank"
                      ? "bg-[#131431]"
                      : "h-11 rounded-lg border-2 border-solid border-white/10 bg-white/5 text-white/50"
                  } relative w-full rounded-none px-3 py-2 text-sm font-normal sm:rounded-lg sm:font-bold`}
                  onClick={() => setActiveButton("bank")}
                >
                  <div className="flex items-center justify-center gap-2">
                    <BankIcon />
                    <div>Card Payment</div>
                  </div>
                  <ComingSoonIcon
                    aspectRatio={0.9}
                    className="absolute -right-1.5 bottom-1.5 w-10 md:-right-2 md:-top-1 md:w-12"
                  />
                </Button>
              </div>
            </div>
            {activeButton === "crypto" ? <CryptoTransfer /> : <CardPayment />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepositTab;
